window.$ = require('jquery');

$(document).ready(function() {
    var stylesheetUrl = "https://use.typekit.net/iot8xch.css";

    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', stylesheetUrl));

});